import React, { useEffect } from "react";
import { Row, Table, Input, Checkbox, Button, InputNumber } from "antd";
import { Delete } from 'react-iconly';
import { toast } from 'react-toast';

export const weightRangeValidator = (_, value) => {
    if (value && value.length > 0) {
        const hasError = value.some((item) => {
            if (item.to_kg !== "" && item.to_kg !== null && item.to_kg !== undefined) {
                return Number(item.to_kg) <= Number(item.from_kg);
            }
            return false;
        });

        if (hasError) {
            return Promise.reject(new Error('To weight must be greater than From weight.'));
        }
    }
    return Promise.resolve();
};

const ServiceWeightRangeSettings = ({ value = [], onChange, options = [] }) => {
    // Use value from props or default to one empty row for display
    const dataSource = (value && value.length > 0) ? value : [
        {
            index: 0,
            from_kg: 0,
            to_kg: "",
            rate_per_order: "",
            methods: []
        }
    ];

    const triggerChange = (newItems) => {
        if (onChange) {
            onChange(newItems);
        }
    };

    const onAddItem = () => {
        const newItems = [...dataSource];
        const lastItem = newItems[newItems.length - 1];

        if (lastItem) {
            let isValid = true;

            if (!lastItem.from_kg && lastItem.from_kg !== 0) isValid = false;
            if (!lastItem.to_kg || !lastItem.rate_per_order) isValid = false;

            if (lastItem.to_kg <= lastItem.from_kg) {
                toast.error("To weight must be greater than From weight.");
                return;
            }

            if (isValid) {
                newItems.push({
                    index: newItems.length,
                    from_kg: Number(lastItem.to_kg) + 0.001,
                    to_kg: "",
                    rate_per_order: "",
                    methods: []
                });
                triggerChange(newItems);
            } else {
                toast.error("Please fill all fields before adding new one.");
            }
        } else {
            // Should not happen if we always have at least one item, but for safety:
            newItems.push({
                index: 0,
                from_kg: 0,
                to_kg: "",
                rate_per_order: "",
                methods: []
            });
            triggerChange(newItems);
        }
    }

    const onRemoveItem = () => {
        const newItems = [...dataSource];
        newItems.pop();
        triggerChange(newItems);
    }

    const onUpdateItem = (index, name, val) => {
        const newItems = dataSource.map((item, i) => {
            if (i === index) {
                return { ...item, [name]: val };
            }
            return item;
        });
        triggerChange(newItems);
    }

    const columns = [
        {
            title: "Weight range",
            width: '45%',
            render: (text, record, index) => (
                <Row align="middle">
                    <InputNumber
                        addonBefore='kg'
                        placeholder="From"
                        disabled
                        value={record.from_kg}
                        onChange={(value) => onUpdateItem(index, 'from_kg', value)}
                    />
                    <span className="ml-8 mr-8">-</span>
                    <InputNumber
                        addonBefore='kg'
                        placeholder="To"
                        value={record.to_kg}
                        onChange={(value) => onUpdateItem(index, 'to_kg', value)}
                    />
                </Row>
            )
        },
        {
            title: "Rate per order",
            render: (text, record, index) => (
                <Input
                    placeholder="Per order"
                    value={record.rate_per_order}
                    onChange={(e) => onUpdateItem(index, 'rate_per_order', e.target.value)}
                />
            )
        },
        {
            title: "Available methods",
            render: (text, record, index) => (
                <Checkbox.Group
                    options={options.length > 0 ? options : record.options}
                    value={record.methods}

                    onChange={(checkedValues) => onUpdateItem(index, 'methods', checkedValues)}
                />
            )
        },
        {
            title: "Action",
            render: (text, record, index) => {
                if (index > 0 && index === dataSource.length - 1) {
                    return (
                        <div className="link" onClick={onRemoveItem}>
                            <Delete set="light" width={24} height={24} />
                        </div>
                    )
                }

                return null;
            }
        }
    ];

    return (
        <div>
            <div className="mb-8">
                <small>Set your own shipping cost calculation rules based on order weight.</small>
            </div>
            <Row className="mb-8" justify="space-between" align="middle">
                <Button type="primary" onClick={onAddItem}>
                    Add row
                </Button>
            </Row>
            <Table
                rowKey="index"
                className="shipment-rate-table"
                columns={columns}
                dataSource={dataSource}
                pagination={false}
            />
        </div>
    )
}

export default ServiceWeightRangeSettings;